import React from "react";
// import CCTV from '../assets/images/cctv2.png'
import HomeAuto from "../assets/images/homeAuto.jpg";
import Procure from "../assets/images/procure.jpg";
import Project from "../assets/images/projector.webp";
import FireAlarm from "../assets/images/fireAlarm.jpg";
import NetworkCable from "../assets/images/networkCab.webp";
import SSM from "../assets/images/ssm.jpg";
import PABX from "../assets/images/pabx.webp";
import Assess from "../assets/images/assessControl.webp";
import Inverter from "../assets/images/inverter.jpg";

const Products = () => {
  const products = [
    {
      id: 1,
      service: "IT Procurement",
      description:
        "We offer a complete range of procurement services designed to reduce costs and save time, allowing you to focus on your core business. We source cost-effective solutions that meet your unique needs.",
      imgPath: Procure,
    },

    {
      id: 2,
      service: "Smart Home Automation",
      description:
        "We specialize in home automation, transforming your residence into a smart home. Our solutions enhance convenience and efficiency, providing a connected and intelligent living environment tailored to your preferences.",
      imgPath: HomeAuto,
    },
    {
      id: 3,
      service: "CCTV Installation",
      description:
        "We excel in providing premier CCTV installation services, whether for your home or business. Our expert team guarantees top-tier security solutions, tailored to your specific needs, ensuring peace of mind.",
      imgPath:
        "https://imgs.search.brave.com/qvEN0r5eE45DvLsiZ4CUjAKJeDCW9EKg1SidG_b6Wk4/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9pbWFn/ZXMudW5zcGxhc2gu/Y29tL3Bob3RvLTE1/MjgzMTI2MzUwMDYt/OGVhMGJjNDllYzYz/P2l4bGliPXJiLTQu/MC4zJml4aWQ9TTN3/eE1qQTNmREI4TUh4/elpXRnlZMmg4TW54/OFkyTjBkaVV5TUdO/aGJXVnlZWHhsYm53/d2ZId3dmSHg4TUE9/PSZ3PTEwMDAmcT04/MA",
    },
    {
      id: 4,
      service: "Audio Visual Solutions",
      description:
        "We provide a wide range of audio-visual devices, catering to your multimedia needs. Our products encompass cutting-edge technology to enhance your audio and visual experiences in various settings.",
      imgPath: Project,
    },
    {
      id: 5,
      service: "Fire Alarm System",
      description:
        "We specialize in the installation of advanced fire alarm systems. Our expertise ensures your safety and protection with reliable, state-of-the-art fire detection and alert solutions for various settings.",
      imgPath: FireAlarm,
    },
    {
      id: 6,
      service: "Servers and Storage Management",
      description:
        "We specialize in server and storage management systems. Our expertise ensures efficient and secure data handling with tailored solutions, enhancing your IT infrastructure for optimal performance and reliability.",
      imgPath:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJjO45u93v6Ut63aPib63YTHa8-1gqFRs1zg&s",
    },
    {
      id: 7,
      service: "Network and Cabling Solution",
      description:
        "We specialize in enterprise networking and cabling solutions. Our services are designed to optimize your network infrastructure, delivering efficient and reliable connectivity for your business operations.",
      imgPath: NetworkCable,
    },
    {
      id: 8,
      service: "PABX and IP Phones",
      description:
        "We specialize in PABX and IP phones. Our solutions enhance communication efficiency, offering advanced telephony systems to streamline your business's voice communication needs with reliability and scalability.",
      imgPath:
        "https://media.licdn.com/dms/image/D5612AQEYoyvQGmhWsQ/article-cover_image-shrink_720_1280/0/1690298952107?e=2147483647&v=beta&t=EIXTVTjAcu-RLT-MRziazez_bxbjAJgc4r34LjFS3hw",
    },
    {
      id: 9,
      service: "Access Control Installation",
      description:
        "We provide comprehensive access control systems, supplying and installing solutions tailored to your security needs. Our expertise ensures secure and efficient control over access to your premises",
      imgPath: Assess,
    },
    {
      id: 10,
      service: "Power Inverter Solutions",
      description:
        "We specialize in the supply and installation of power inverters. Our solutions deliver reliable backup power, ensuring continuity during outages and supporting a seamless operation of your systems.",
      imgPath: Inverter,
    },
  ];
  return (
    <>
      <section className="container mx-auto my-5 px-6 sm:px-0">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          {products.map((product) => (
            <>
              <div
                key={product.id}
                className="grid mx-auto gap-6 py-10 px-4 shadow-lg rounded-xl"
              >
                <img
                  src={product.imgPath}
                  alt=""
                  className="w-full h-64 object-cover rounded-2xl"
                />
                <div className="flex flex-col space-y-3">
                  <p className="text-2xl text-darkBlue">{product.service}</p>
                  <p className="text-darkBlue opacity-80">
                    {product.description}
                  </p>
                </div>
              </div>
            </>
          ))}
        </div>
      </section>
    </>
  );
};

export default Products;
